import React from "react";
import InsightsProductForm from "../../components/InsightsProductForm";
import { Container, CSSReset, Box, Heading } from "@chakra-ui/react";

const NewProduct: React.FC = () => {
  return (
    <Container maxWidth={1250}>
      <CSSReset />
      <Box borderWidth={1} p={5} borderRadius={5} shadow="lg">
        <Heading as="h3" size="lg">
          New Product
        </Heading>

        <Box mt={5}>
          <InsightsProductForm product={null} />
        </Box>
      </Box>
    </Container>
  );
};

export default NewProduct;
